export default __webpack_public_path__ + "static/media/usaFlag.c1e2ba3f.svg";